/* Uoma A/A v2. Own page only. Measurement unit is this browser, not a person.
 * Owner-directed all-visitor pilot. Does not change Shopify consent settings.
 * No names, addresses, emails, IPs, click IDs, referrers or page URLs are sent.
 */
(() => {
  const root=document.querySelector('[data-vaistoa-pilot]');
  if(!root||!['qa','live'].includes(root.dataset.mode)||root.dataset.locale!=='en')return;
  const api='https://vaistoa-cro-studio.vercel.app',mode=root.dataset.mode;
  const key=`vaistoa_cro_aa_v2_${mode}`,attribute='vaistoa_cro_aa_v2',property='_vaistoa_cro_aa_v2';
  const uuid=/^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/;
  if(!crypto.randomUUID)return;
  let token=null,ready=false,identity=null,earlyPurchase=false;
  const cartPath=part=>`${root.dataset.root.replace(/\/$/,'')}/${part}`;
  const status=value=>{root.dataset.state=value;};
  const forms=()=>[...document.querySelectorAll('form[action*="/cart/add"]')].filter(form=>form.closest('[data-section-type="product"]'));
  const post=async(path,payload)=>{
    for(let attempt=0;attempt<2;attempt++){
      try{
        const response=await fetch(api+path,{method:'POST',headers:{'Content-Type':'application/json'},credentials:'omit',referrerPolicy:'no-referrer',body:JSON.stringify(payload),signal:AbortSignal.timeout(12000)});
        if(!response.ok){if(response.status<500)throw Error('request rejected');throw Error('measurement unavailable');}
        return response.status===204?null:response.json();
      }catch(error){if(attempt||error.message==='request rejected')throw error;}
    }
  };
  const event=kind=>token?post('/api/pilot/events',{token,eventId:crypto.randomUUID(),kind}):Promise.resolve();
  function tagForms(){
    for(const form of forms()){
      let input=form.querySelector(`input[name="properties[${property}]"]`);
      if(!input){input=document.createElement('input');input.type='hidden';input.name=`properties[${property}]`;form.append(input);}
      input.value=token;
    }
  }
  // Record quick purchases instead of silently asserting complete attribution.
  document.addEventListener('submit',eventObject=>{
    if(eventObject.target.matches?.('form[action*="/cart/add"]')&&!ready){
      earlyPurchase=true;if(token)event('purchase_before_ready').catch(()=>{});
    }
  },true);
  document.querySelector('[data-section-type="product"]')?.addEventListener('variantChange',eventObject=>{
    if(eventObject.detail?.variant?.id){const url=new URL(location.href);url.searchParams.set('variant',String(eventObject.detail.variant.id));history.replaceState(history.state,'',url);}
    if(token)tagForms();
  });
  async function mount(){
    let saved;
    try{saved=JSON.parse(localStorage.getItem(key));}catch{saved=null;}
    if(saved&&uuid.test(saved.visitor)&&Number.isFinite(saved.createdAt)&&Date.now()-saved.createdAt<30*86400000&&saved.createdAt<=Date.now())identity=saved;
    else {identity={visitor:crypto.randomUUID(),createdAt:Date.now()};localStorage.setItem(key,JSON.stringify(identity));}
    // Test persistence before enrollment: do not fabricate a new browser on every page load.
    if(JSON.parse(localStorage.getItem(key))?.visitor!==identity.visitor)throw Error('storage unavailable');
    // Reuse a durably acknowledged assignment during the follow-up window,
    // when new enrollment has closed. The server still validates every token.
    let enrolled;
    try{
      const proof=JSON.parse(atob((identity.token||'').split('.')[0].replace(/-/g,'+').replace(/_/g,'/')));
      if(proof.v===identity.visitor&&proof.e===`uoma-en-aa-v2${mode==='qa'?'-qa':''}`&&proof.r===2&&['A','B'].includes(proof.g))enrolled={token:identity.token,group:proof.g};
    }catch{}
    status('enrolling');
    enrolled??=await post('/api/pilot/enroll',{visitor:identity.visitor,mode,locale:root.dataset.locale,country:root.dataset.country});
    token=enrolled.token;root.dataset.group=enrolled.group;
    identity.token=token;localStorage.setItem(key,JSON.stringify(identity));
    tagForms();status('linking-cart');
    const telemetry=Promise.allSettled([event('form_tagged'),event('page_exposed'),...(earlyPurchase?[event('purchase_before_ready')]:[])]);
    const response=await fetch(cartPath('cart.js'),{credentials:'same-origin',signal:AbortSignal.timeout(5000)});
    if(!response.ok)throw Error('cart read');
    const cart=await response.json(),previous=cart.attributes?.[attribute];
    if(previous&&previous!==token){status('cart-conflict');await event('cart_conflict');return;}
    if(!previous){
      const linked=await fetch(cartPath('cart/update.js'),{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{[attribute]:token}}),signal:AbortSignal.timeout(5000)});
      if(!linked.ok||(await linked.json()).attributes?.[attribute]!==token){status('cart-link-failed');await event('cart_link_failed');return;}
    }
    await event('cart_linked');const observations=await telemetry;
    ready=true;status(observations.some(r=>r.status==='rejected')?'telemetry-incomplete':'ready');
  }
  status('starting');
  // navigator.locks serializes identity creation and cart tagging across tabs.
  // Unsupported browsers fail visibly in QA; they are not reported as measured.
  if(!navigator.locks){status('unsupported-locks');return;}
  navigator.locks.request(key,mount).catch(()=>{status(`${root.dataset.state}-failed`);});
})();
